import { Colors, Services, getPrice } from '@sigma-frontend-libs/commons'

import { buttonModes, components, sizes } from '@/utils'

import button from '@/components/button'
import dialog from '@/components/services/tariffs/rules/rule/packets/dialog'
import tag from '@/components/tag'

const baseClass = 'packets'

function renderDialog(h) {
  return h(
    dialog,
    {
      props: {
        value: this.showDialog,
        data: this.proxy
      },
      on: {
        input: event => {
          this.showDialog = event
        },
        save: event => {
          this.proxy = event
        }
      }
    }
  )
}

function renderTitle(h) {
  return h(
    tag,
    {
      props: {
        label: this.getTranslate(`${Services.tariffs}.titles.${baseClass}`),
        size: sizes.medium,
        color: Colors.grey
      }
    }
  )
}
function renderClearButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.clear'),
        mode: buttonModes.flat,
        size: sizes.small,
        color: Colors.error,
        disabled: !this.proxy.length
      },
      on: {
        click: () => {
          return this.remove()
        }
      }
    }
  )
}
function renderAddButton(h) {
  let color = Colors.success
  let label = this.getTranslate('misc.buttons.add')
  if (this.proxy.length) {
    color = Colors.primary
    label = this.getTranslate('misc.buttons.edit')
  }

  return h(
    button,
    {
      props: {
        mode: buttonModes.flat,
        size: sizes.small,
        color,
        label
      },
      on: {
        click: () => {
          this.showDialog = true
        }
      },
      scopedSlots: {
        dialog: () => {
          return renderDialog.call(this, h)
        }
      }
    }
  )
}

function renderActions(h) {
  if (!this.readonly) {
    return h(
      'div',
      {
        class: `${Services.tariffs}-rule__${baseClass}-header__actions`
      },
      [
        renderClearButton.call(this, h),
        renderAddButton.call(this, h)
      ]
    )
  }
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: `${Services.tariffs}-rule__${baseClass}-header`
    },
    [
      renderTitle.call(this, h),
      renderActions.call(this, h)
    ]
  )
}

function renderTagContent(h, item) {
  return h(
    'div',
    {
      class: `${Services.tariffs}-rule__${baseClass}-tag`
    },
    [
      h('span', { class: 'text--grey' }, [ `${item.priority + 1}: ` ]),
      h('span', {}, [ `${item.size} (${getPrice(item.price)})` ])
    ]
  )
}
function renderTag(h, item, index) {
  return h(
    tag,
    {
      props: {
        size: sizes.small,
        cancelable: !this.readonly,
        cancel: () => {
          return this.remove(index)
        },
        tooltip: this.getTagTooltip(item),
        tooltipOptions: { placement: 'top-start' }
      },
      scopedSlots: {
        default: () => {
          return renderTagContent.call(this, h, item)
        }
      },
      key: `${baseClass}_${item.priority}_${item.size}_${item.price}_${index}`
    }
  )
}
function renderTags(h) {
  if (Array.isArray(this.proxy) && this.proxy.length) {
    return this.proxy.map((item, index) => {
      return renderTag.call(this, h, item, index)
    })
  }

  return h(
    components.empty,
    {
      props: {
        size: 48,
        padless: true
      }
    }
  )
}
function renderBody(h) {
  return h(
    'div',
    {
      class: `${Services.tariffs}-rule__${baseClass}-body`
    },
    [ renderTags.call(this, h) ]
  )
}

export default function(h) {
  if (this.readonly && !this.proxy.length) {
    return
  }

  return h(
    'div',
    {
      class: `${Services.tariffs}-rule__${baseClass}`
    },
    [
      renderHeader.call(this, h),
      renderBody.call(this, h)
    ]
  )
}
